
const WA_LINK = `https://wa.me/919418040013?text=${encodeURIComponent('Hi! I would like to enquire about a stay at Scenic Solitude, Sojha.')}`
const MAPS_URL = 'https://maps.app.goo.gl/dtcNRhkxs7jkZFGM7'

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.95 11 19.79 19.79 0 01.88 2.38 2 2 0 012.86.18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.06 6.06l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
    </svg>
  )
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2"/>
      <path d="M2 7l10 7 10-7"/>
    </svg>
  )
}



function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  )
}

export default function Contact() {
  return (
    <div className="min-h-screen bg-cream-100">

      {/* Hero */}
      <div className="relative h-64 lg:h-80 overflow-hidden">
        <img src="/images/optimized/IMG_5095.webp" fetchPriority="high"
          className="h-full w-full object-cover" alt="Scenic Solitude" />
        <div className="absolute inset-0 bg-forest-950/55" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <p className="text-[10px] tracking-[0.35em] uppercase text-white/55 font-semibold mb-3">Reach Out</p>
          <h1 className="text-4xl font-semibold text-white tracking-tight">Contact Us</h1>
          <p className="mt-2 text-sm text-white/60">Sojha · Kullu District · Himachal Pradesh</p>
        </div>
      </div>

      {/* Forest green info bar */}
      {/* Body */}
      <div className="mx-auto max-w-5xl px-8 lg:px-16 py-20">

        {/* Contact cards — phone + 2 emails only */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-cream-300 border border-cream-300 mb-16">
          {[
            { icon: <PhoneIcon />, label: 'Phone / WhatsApp', value: '+91 94180 40013', href: WA_LINK, external: true },
            { icon: <MailIcon />, label: 'General Enquiries', value: 'info@scenicsolitudehimalayas.com', href: 'mailto:info@scenicsolitudehimalayas.com' },
            { icon: <MailIcon />, label: 'Bookings', value: 'bookings@scenicsolitudehimalayas.com', href: 'mailto:bookings@scenicsolitudehimalayas.com' },
          ].map(item => (
            <a key={item.label} href={item.href}
              {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              className="bg-cream-100 px-6 py-8 flex flex-col gap-3 transition-all duration-300 group hover:bg-cream-50"
              style={{ '--tw-shadow': '0 0 0 0 transparent' } as React.CSSProperties}
              onMouseEnter={e => (e.currentTarget.style.boxShadow = 'inset 0 0 0 1px #2d5a3d, 0 4px 24px 0 rgba(30,53,37,0.18)')}
              onMouseLeave={e => (e.currentTarget.style.boxShadow = 'none')}>
              <div className="text-ink-muted group-hover:text-ink transition-colors">{item.icon}</div>
              <div>
                <p className="text-[9px] tracking-[0.3em] uppercase text-ink-muted mb-1">{item.label}</p>
                <p className="text-sm text-ink font-light leading-snug">{item.value}</p>
              </div>
            </a>
          ))}
        </div>

        {/* Map — smaller, blurred edges */}
        <div className="relative overflow-hidden border border-cream-300" style={{ borderRadius: 0 }}>
          {/* fade edges */}
          <div className="absolute inset-y-0 left-0 w-12 z-10 pointer-events-none"
            style={{ background: 'linear-gradient(to right, var(--color-cream-100, #f5f0e8), transparent)' }} />
          <div className="absolute inset-y-0 right-0 w-12 z-10 pointer-events-none"
            style={{ background: 'linear-gradient(to left, var(--color-cream-100, #f5f0e8), transparent)' }} />
          <div className="absolute inset-x-0 top-0 h-8 z-10 pointer-events-none"
            style={{ background: 'linear-gradient(to bottom, var(--color-cream-100, #f5f0e8), transparent)' }} />
          <div className="absolute inset-x-0 bottom-0 h-8 z-10 pointer-events-none"
            style={{ background: 'linear-gradient(to top, var(--color-cream-100, #f5f0e8), transparent)' }} />
          <iframe
            title="Scenic Solitude location"
            src="https://maps.google.com/maps?q=31.566823,77.370206&t=&z=15&ie=UTF8&iwloc=&output=embed"
            className="w-full h-64 lg:h-80 opacity-85"
            loading="lazy"
          />
        </div>

        <div className="mt-4 flex justify-end">
          <a href={MAPS_URL} target="_blank" rel="noopener noreferrer"
            className="text-xs text-ink-muted hover:text-ink transition-colors">
            Open in Google Maps ↗
          </a>
        </div>

        {/* CTAs — centred */}
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-5">
          <a href="/inquire" className="btn-outline-aman text-ink min-w-[180px] text-center">
            Send an Enquiry
          </a>
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 min-w-[180px] px-6 py-2.5 bg-[#25D366] text-white text-[11px] tracking-widest2 uppercase hover:bg-[#1ebe5d] transition-colors duration-200">
            <WhatsAppIcon />
            Chat on WhatsApp
          </a>
        </div>

      </div>
    </div>
  )
}
